import React from "react";

const NotFound = () => (
  <div className="container">
    <div className="row">
      <div className="col-xs-12">
        <h1>404</h1>
        <h3>Not found</h3>
        <p>The path you've requested was not found - sorry!</p>
      </div>
    </div>
  </div>
);

export default NotFound;
